import { t } from '@lingui/macro';
import { CreateQuestionInput } from '../..';

const QUESTION_DATABASE = (): CreateQuestionInput[] => [
  {
    text: t`What is your name?`,
    stringDefinition: {},
  },
  {
    text: t`What is your age?`,
    numericDefinition: {
      minValue: 0,
      maxValue: 120,
    },
  },
  {
    text: t`Which company do you work for?`,
    stringDefinition: {},
  },
  {
    text: t`What is the highest degree or level of school you have completed?`,
    checkboxesDefinition: {
      options: [
        { text: t`No schooling completed` },
        { text: t`Nursery school to 8th grade` },
        { text: t`Some high school, no diploma` },
        {
          text: t`High school graduate, diploma or the equivalent (for example: GED)`,
        },
        { text: t`Some college credit, no degree` },
        { text: t`Trade/technical/vocational training` },
        { text: t`Associate degree` },
        { text: t`Bachelor’s degree` },
        { text: t`Master’s degree` },
        { text: t`Professional degree` },
        { text: t`Doctorate degree` },
      ],
    },
  },
  {
    text: t`What is your marital status?`,
    checkboxesDefinition: {
      options: [
        { text: t`Single, never married` },
        { text: t`Married or domestic partnership` },
        { text: t`Widowed` },
        {
          text: t`Divorced`,
        },
        { text: t`Separated` },
      ],
    },
  },
];

export default QUESTION_DATABASE;
